import { Button } from '@mui/material';
import React from 'react';
import { colors } from '../index';

export default function SubmitButton({ disabled, children }) {
  return (
    <Button
      variant="contained"
      type="submit"
      disabled={disabled}
      sx={{ backgroundColor: colors.primary, color: colors.background }}
    >
      {children}
    </Button>
  );
}
